import React from 'react';
import PropTypes from 'prop-types';
import { StatePill } from '@common/components';
import { FontSizes } from 'works/legacy/lib/style-helper';

const STATUS_COLOR = {
  pending: 'elm-darker',
};

export const StatusPill = ({ status }) => (
  <StatePill
    color={STATUS_COLOR[status]}
    fontSize={FontSizes.small}
    capitalized
  >
    {status.toLowerCase()}
  </StatePill>
);

StatusPill.propTypes = {
  status: PropTypes.string.isRequired,
};
